import { useEffect, useRef } from "react";

export default function SlidePage({bg, title, comment, className, index}){
  const path = bg?? 'assets/images/home/visual05.jpg';
  const url = `url(${path})`;
  const ref = useRef();
  const titleRef = useRef();
  const commentRef = useRef();

  useEffect(()=>{
    setTimeout(()=>{
      ref.current?.classList.remove('hidden');
      ref.current?.classList.add('flex');
      ref.current?.classList.add('imageAnimation');
      titleRef.current?.classList.add('titleAnimation');
      commentRef.current?.classList.add('commentAnimation')
    }, (index*6000));
  },[index]);

  return (
    <div ref={ref} className={`${className} hidden w-full flex-col lg:items-center items-stretch justify-center h-full`}
    style={{backgroundImage:url}} >
      <div className="relative lg:w-[1200px]">
        <div className="z-20 flex flex-col items-start justify-center lg:my-20 px-mobile lg:px-0 w-full lg:w-[1200px]">
          <p ref={titleRef} className={`mb-4 text-4xl  font-medium text-gray-200 lg:text-7xl`}
            dangerouslySetInnerHTML={{__html:title}}></p>
          <p ref={commentRef} className={`mt-4 text-base lg:text-2xl text-gray-200 `}
            dangerouslySetInnerHTML={{__html:comment}}></p>
        </div>
      </div>
    </div>
  );
}